import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { API } from "../../backend";
import { ReactComponent as Error } from "../../assets/error.svg";
import { ReactComponent as Linkedin } from "../../assets/linkedin.svg";
import { ReactComponent as Facebook } from "../../assets/facebook.svg";
import { ReactComponent as Twitter } from "../../assets/twitter.svg";
import { ReactComponent as Youtube } from "../../assets/youtube.svg";
import "./Login.css";

interface loginUserData {
  email1: string;
  password1: string;
}

const Login = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState<loginUserData>({
    email1: "",
    password1: "",
  });
  const [errorMess, setErrorMess] = useState<string>("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  const signin = async (
    e: React.FormEvent<HTMLFormElement>,
    userData: loginUserData,
    clear: () => void
  ) => {
    e.preventDefault();
    if (!userData?.email1 && !userData?.password1) {
      return setErrorMess("Email and Password is required");
    } else if (!userData?.email1) {
      return setErrorMess("Email is required");
    } else if (!userData?.password1) {
      return setErrorMess("Password is required");
    }

    try {
      const signinResp = await fetch(`${API}/signin`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: userData?.email1,
          password: userData?.password1,
        }),
      });

      const response = await signinResp.json();
      if (response?.token) {
        if (typeof window !== "undefined") {
          localStorage.setItem("jwt", JSON.stringify(response));
          clear();
          setErrorMess("");
          navigate("/", {
            state: {
              loggedIn: true,
            },
            replace: true,
          });
        }
      } else {
        setErrorMess(response?.message || "Invalid Email or Password");
      }
    } catch (error) {
      setErrorMess("Something went wrong");
      console.error("Something went wrong", error);
    }
  };

  return (
    <div className="login-action-form">
      <form
        className="login-form"
        onSubmit={(e) =>
          signin(e, userData, () => {
            setUserData({
              email1: "",
              password1: "",
            });
          })
        }
      >
        <div className="content">
          <h2 className="header">Sign In</h2>
          <input
            onChange={handleChange}
            name="email1"
            type="email"
            placeholder="Email"
            id="email1"
          />
          <input
            onChange={handleChange}
            name="password1"
            type="password"
            placeholder="Password"
            id="password1"
          />
          {errorMess && (
            <h2 className="errorMessage">
              <Error className="errorIcon" />
              {errorMess}
            </h2>
          )}
          <button type="submit" className="submit-btn">
            Sign in
          </button>
          <Link to="/signup" className="subLink">
            New user? Signup
          </Link>
        </div>
      </form>
      <div className="social">
        <h2>Connect with us</h2>
        <div className="social-btns">
          <a
            href="https://www.youtube.com/channel/UCb1GdqUqArXMQ3RS86lqqOw"
            target={"_blank"}
            rel="noreferrer"
          >
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAilBMVEX/////AAD/WVn/sbH/nJz/8fH/Kir/4uL/3t7/zs7/xsb/YGD/7e3/GBj/9fX/y8v/trb/19f/PT3/oaH/jIz/goL/fX3/c3P/bm7/paX/NDT/Dg7/SEj/+vr/wcH/vLz/VFT/IiL/aGj/k5P/UFD/LS3/X1//iYn/gID/Ojr/srL/nZ3/RUX/d3eHgOMVAAAEkklEQVR4nO2d22KiQAyGWdQFBRE84QnBc9ut7/96i9tuz4ZBAiPh/+560Zn8LTCTZCYxDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzSPyOq5l2UHQ7XYHg9469lut+ai9241Pk+k5nG23W8c5mmaSJKZ5dJz051l4nk5O492uPZq3Wn687g0G6W8HgW1ZbseLdKqJPNcKuuu4Nd9NQmf/PFwcNpv+8hcfy/5mc1gMn/dOONnNW/G6G1iuF5Ws2nPtgZ9qmiVDXjnKoofJLNXrD2zX4xbXsf3TcVG9qmssF8eTb3eY1LlxOLwfbR9ZDs+xW1Re1Nv2dQsh6W97hV7OONGtQIEkvllfJ9RtvCLhjW9k76DbcmUOvVsE+rrNzsU8v8C2bptz0pYuMPd/saXb3hvw8wgMdFt7E4G6QG+l29ibWKnvVk+6bb2Rk+xn9IKtqPBBt6E386Am0LpPT0KFpaWksH5L4Ttq6349P6QvrJQeUt1WFkLlMX3SbWQhWgoKJ7qNLITK13Sv28hCrLJjGu59x2Wy6GeHpga6bSxItrf/R7eJBcleEesSfbpGmCUwqvN6f2Gf9anxfus2sSC/s5zEGm+7X8jcfHd1W1iYbobCWLeBhcmK8Y90G1iYUYbCqW4DCzPNUHjUbWBhjhkKh7oNLMwwQ2Hdl8N0QaQFdlg9Cy1ra59OJvKGMEx/wTqeGvSSzxsMNo1oV727SacveqxzmZen4sw6pAK0h8ibVTP/jTmo2F2hg1G80WDzddSnSk8E0D7wmHWu/wqNzrjCz+qYVMi7aTPfB7ZnrCNT0Ns2XjvMj0P3nlnHvs6MVOiwzmV+HnxezYbJIRXynvL6otBwK0kuJ6RC3g/7V4XpjoL3IfkRMv8UPbLO9V2hYaxL38g9UtG2iHf6nxQa3mjDOsk3FpRC5ljijwrT17HcQAIZT+xsWOe6ojB9HctMcG0o94k58XRVoWGU6FeR6SeXd3NFKDS80vyqJaWQOYdPKUwnKysJRLnAlSosza+6I4WpP1rGRo5SaPNOla3QcEvwq6jTbcxn9hQUpn/VLe+kdKCGOfOkpJDfr6KyT7yBKFWFRjTfcE5LhaKYc2uqCtPXkfOcEpVf06Yw/QSYbNNSCplvkeRRmP55ubJC1KF95ksI+RSmfhXPRo4KmM5ZZngjp0KuADl1t0S3wtQChg3APSss/38o/z2U/y2Vvx7K39PI35fK9y3k+4fyfXz5cRrE2nJyh/FS+TFv+XkL+bkn+flD+Tlg+Xl8+WcxGnCeRv6ZKPnn2uSfTZR/vlT+GWH557zln9WXf99C/p0Z+fee5N9da8D9Q/l3SOXfA5Z/l1v+fXz5NRXk18WQX9tEfn0a+TWGGlAnSn6tL/n12uTX3GtA3UT5tS/l1y+VX4O2AXWEa7z5VqwFLb+eN/fptgpR7h0gvq5+A3oj1LR3QI7+Fg3oUVLHRTF3t6C6SczdK6gB/Z4a0LOrAX3XDPm984wG9D+8ILyH5Suy+5C+IbqX7GfE9gOmVYvq6QwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQBd/AeVenzu8wDl+AAAAAElFTkSuQmCC"
              width={`30px`}
            />
          </a>
          <a
            href="https://twitter.com/iNeuronAi"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://www.freepnglogos.com/uploads/twitter-logo-png/twitter-bird-symbols-png-logo-0.png"
              width={`30px`}
            />
          </a>
          <a
            href="https://www.linkedin.com/company/ineuron-ai"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://www.freeiconspng.com/thumbs/linkedin-logo-png/linkedin-logo-1.png"
              width={`30px`}
            />
          </a>
          <a
            href="https://ineuron.ai/facebook/abcde"
            target={"_blank"}
            rel="noreferrer"
          >
            <img
              src="https://www.freepnglogos.com/uploads/facebook-logo-icon/facebook-logo-clipart-flat-facebook-logo-png-icon-circle-22.png"
              width={`30px`}
            />
          </a>
        </div>
      </div>
      {/* <h2 className="iframe-title">Know About Us in detail</h2>
      <iframe
        id="iframe_example"
        title="Iframe Example"
        // width="300"
        height="300"
        src="https://ineuron.ai/about-us"
      ></iframe> */}
    </div>
  );
};

export default Login;
